import { IQueryResponse } from '@bookips/solvook-api-shared'
import { api } from '.'
interface IGetPublisher {
	id: string
}
interface IGetPublisherRes extends IQueryResponse {
	publisher: Publisher
}
interface Publisher {
	id: number
	uid?: string

	email: string

	name: string
	nickname?: string

	pub_cd: string

	picture?: string

	created_at?: Date
	updated_at?: Date

	last_sign_in_at?: Date
	deleted_at?: Date
	blocked_at?: Date

	options?: object
}
export const getPublisher = async ({ id }: IGetPublisher) => {
	const { data } = await api.get<IGetPublisherRes>(`/publishers/${id}`)
	return data
}
